import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useParams } from "react-router-dom";
import { setHasVoting, setTabSelected } from '../redux/data/dataSlice';
import { getGames } from '../redux/data/dataActions';
import { setupMetaData, setupBaseMetaData } from "../utils/metaData";
import { injectPageScripts } from "../utils/loadScripts";
import { getCurrentEnv } from "../utils/environment";
import config from "../config/memberhubContents.json";
import FrameModal from "./frameModal";
import RewardModal from "./rewardModal";
import RewardSection from "./rewardSection";
import TabSectionHeader from "./tabSectionHeader";
import "../assets/css/voting.css";
import "../assets/css/header.css";

function Games() {
    const dispatch = useDispatch();
    const params = useParams();

    const [rewardCount, setRewardCount] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [selectedCampaign, setSelectedCampaign] = useState(null);
    const [refreshGames, setRefreshGames] = useState(true);
    const gamesSections = useSelector(state => state.data.gamesSections);
    const userType = useSelector(state => state.data.userType);
    const gamesRewardSectionNum = "6";

    const checkRewardSection = rewardSection => {
        // reward section is a comma separated string of values
        if (rewardSection && rewardSection.length > 0) {
            let sections = rewardSection.split(',');
            return sections.find(s => s === gamesRewardSectionNum);
        }
        return;
    };

    const openModal = (activity) => {
        setSelectedCampaign(activity);
        setShowModal(true);
    };

    const addPageAnalytics = () => {
        window.digitalData.page.pageInfo.pageName = "nba:membership-hub:voting";
        window.digitalData.page.pageInfo.siteSection = "nba:membership-hub";
        window.digitalData.page.content = { categoryTitle: "Voting", categoryType: "membership-hub" };
        window.digitalData.site = { propertyName: "nba:web", league: "nba" };
        if (window.digitalData.user) {
            window.digitalData.user.userState = "authenticated";
            window.digitalData.user.userType = userType;
        }

        console.log("Voting: analytics added");
    };

    useEffect(() => {
        const clickedOnVote = window.location.search.includes("cl=1"); // as opposed to deep link to vote
        if (!clickedOnVote && (!params || !params.activityId)) { // clicking on vote should not trigger tab analytics
            addPageAnalytics();
            setupBaseMetaData();
        }
        injectPageScripts();
    }, [params]);

    const handleMessage = useCallback((event) => {
        try {
            if (event.data.identifier === "redirectRequest" && event.data.url) {
                const currentEnv = getCurrentEnv();
                let envUrl = currentEnv === "prod" ? event.data.url : event.data.url.replace("://www.nba.com/", `://www-${currentEnv}.nba.com/`);
                if (!envUrl.includes("redirect-to-membership-hub")) {
                    envUrl = envUrl + "?redirect-to-membership-hub";
                }
                localStorage.setItem('href', document.location.href);
                if (envUrl.startsWith("http")) {
                    window.location.href = envUrl;
                }
            }
        } catch (error) {
            console.log(error);
        }
    }, []);

    useEffect(() => {
        window.addEventListener("message", handleMessage, false);
        return () => {
            window.removeEventListener("message", handleMessage);
        }
    }, [handleMessage]);

    useEffect(() => {
        console.log("Games: useEffect[dispatch]");
        dispatch(setTabSelected("voting"));
        if (refreshGames) {
            dispatch(getGames());
            setRefreshGames(false);
        }
        console.log("tabSelected: voting");
    }, [dispatch]);

    useEffect(() => {
        console.log("Games: useEffect[dispatch, gamesSections]");
        if (gamesSections && gamesSections.rewards && gamesSections.rewards.length > 0) {
            dispatch(setHasVoting(true));
            let count = new Set();
            if(gamesSections && gamesSections.rewards && gamesSections.rewards.length > 0) {
                gamesSections.rewards.forEach(reward => {
                    count.add(reward.id);
                });
            }
            setRewardCount(count.size);
        } else {
            dispatch(setHasVoting(false));
        }
    }, [dispatch, gamesSections]);

    useEffect(() => {
        console.log("Games: useEffect[showModal]");

        const bodyElement = document.getElementById("body");
        if (bodyElement) {
            if (showModal) {
                if (!bodyElement.className.includes("modal-noscroll")) {
                    bodyElement.className += " modal-noscroll";
                }
            } else {
                if (bodyElement.className.includes("modal-noscroll")) {
                    bodyElement.className = bodyElement.className.replace(" modal-noscroll", "");
                }
            }
        }

    }, [showModal]);

    useEffect(() => {
        console.log("Games: useEffect[params, gamesSections]");

        const setupGamesMetaData = (activity) => {
            if (activity) {
                let title = `NBA ID | Games | ${activity.title}`;
                let desc = activity.description;
                let imageUrl = activity.image;

                setupMetaData(title, desc, imageUrl);
            }
        };

        if (params && params.activityId && gamesSections) {
            let activities = [];

            if (gamesSections && gamesSections.rewards) {
                let activity = gamesSections.rewards.find(activity => String(activity.id) === String(params.activityId));
                if (activity) { activities.push(activity); }
            }

            if (activities.length > 0) {
                let activity = activities.pop();
                console.log(activity);
                setupGamesMetaData(activity);
                openModal(activity);
            }
        }
    }, [params, gamesSections]);

    let renderModal = () => {
        return (
            <>
                {selectedCampaign && selectedCampaign.extra_data.game &&
                    <FrameModal title={selectedCampaign.title} campaignUrl={selectedCampaign.extra_data.game} setShowModal={setShowModal} />
                }
                {selectedCampaign && !selectedCampaign.extra_data.game && selectedCampaign.extra_data.host &&
                    selectedCampaign.extra_data.project_id && selectedCampaign.extra_data.event_id &&
                    <FrameModal
                        title={selectedCampaign.title}
                        campaignUrl={`/monterosa.htm?id=${encodeURIComponent(selectedCampaign.extra_data.project_id)}&e=${encodeURIComponent(selectedCampaign.extra_data.event_id)}`}
                        setShowModal={setShowModal} />
                }
                {selectedCampaign && selectedCampaign.extra_data.reward_section && checkRewardSection(selectedCampaign.extra_data.reward_section) &&
                    <div className="modal-container">
                        <div className="modal-background">
                        </div>
                        <div className="modal-dialog">
                            <RewardModal selectedReward={selectedCampaign} setShowModal={setShowModal} />
                        </div>
                    </div>
                }
            </>
        );
    };

    return (
        <div id="voting-container">
            <TabSectionHeader title={config.votingHeading} subtitle={config.votingPageTopDescription}
                count={rewardCount} countText="available" />
            <div className="title-bar"></div>
            <RewardSection tabSelected="voting" section={gamesSections && gamesSections.rewards && gamesSections.rewards.length > 0 ? gamesSections : { title: config.votingTitle, subtitle: config.noActivityDescription }} />
            {showModal && renderModal()}
        </div>
    );
}

export default Games;
